import { atom } from 'recoil';

let commonCodes = atom<any>({
  key: 'commonCodes',
  default: [],
});

let partners = atom<any>({
  key: 'partners',
  default: [],
});

let useMtgLoan = atom<boolean>({
  key: 'useMtgLoan',
  default: true,
});

export { commonCodes, partners, useMtgLoan };
